<template>
    <div data-app class="main-content--payer">
        <router-view></router-view>
        <Preloader v-show="showPreloader" />
        <app-version-checker></app-version-checker>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Preloader from '../common_components/Preloader.vue';
    import VersionChecker from '../common_components/VersionChecker.vue';

    export default {
        components: {
            Preloader,
            appVersionChecker: VersionChecker,
        },
        data: () => ({
            start: 'test',
            currentRouter: null,
            mobile: window.innerWidth > 767
        }),
        computed: {
            ...mapGetters([
                'students_payer',
                'showPreloader',
            ])
        },
        methods: {
            login() {
                this.$store.dispatch('whoami');
            },
            isProfile() {
                return this.$route.name === 'profile'
            }
        },
        created() {
            this.login();
        },
        mounted(){
            this.$nextTick(() => {
                this.calcHeight();
                this.currentRouter = this.$router.history.current.name;
            });
        },
        watch: {
            '$route'() {
                let nextRoute = this.$router.history.current.name;
                if (this.currentRouter !== nextRoute && this.mobile){
                    this.calcHeight();
                    this.currentRouter = this.$router.history.current.name;
                }
                this.$store.commit('SET_SEARCH_VALUE', '')
            },
            students_payer(val) {
                if (val !== null && this.mobile) {
                    this.calcHeight();
                }
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "../../sass/app"
</style>
